import React from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";
;
import {fetchMyInvoices} from "./../actions/InvoiceActions";
import { SECONDARY_JAUNE_COLOR } from '../constants/colors';
import WalletIcon from './../svgComponents/WalletIcon.jsx';
import PersonIcon from './../svgComponents/PersonIcon.jsx';
import DocumentIcon from './../svgComponents/DocumentIcon.jsx';
@connect ((store) =>{
     return {
       messages:store.messages.messages
     }
  }
)
export default class SideMenu extends React.Component {
  constructor() {
    super();
  }

  render(){
    const {messages} = this.props;
    return (
      <div class="side-nav">
        <div className="container-fluid">
            <ul>
              <li>
                <Link to={subscriptionDetails_url.path}>
                <span><WalletIcon className='sideIconMenu' /></span>
                    <span >{messages["common.menu.my.subscriptions"]}</span>
                    <span><i class="fa fa-angle-right sideMenuClass"></i></span>
                </Link>
              </li>
              <li>
                <Link to={myInvoicesDetails_url.path}>
                  <span><DocumentIcon className='sideIconMenu' /></span>
                  <span >{messages["common.menu.my.invoices"]}</span>
                  <span><i class="fa fa-angle-right sideMenuClass"></i></span>
                </Link>
              </li>
              <li>
                <Link to={mesCoordonnees_url.path}>
                  <span><PersonIcon className='sideIconMenu' /></span>
                  <span>{messages["common.menu.info.details"]}</span>
                  <span><i class="fa fa-angle-right sideMenuClass"></i></span>
                </Link>
              </li>
              <li>
                <a target='_blank' href={myAssistance_url}>
                  <span><i class="fa fa-question-circle sideIconMenu" ></i></span>
                  <span>{messages["common.menu.my.assistance"]}</span>
                  <span><i class="fa fa-angle-right sideMenuClass"></i></span>
                </a>
      				</li>
      			</ul>
      	</div>
      </div>

  );
}
}



// WEBPACK FOOTER //
// ./src/opencell/pages/SideMenu.jsx